export default __webpack_public_path__ + "static/media/DAP.feea37af.png";